import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { darkColors } from "../../theme/colors";
import InlineSvg from "./inline-svg";

const ConnectButton = styled(Button)(
  ({
    theme,
    backgroundColor,
    width,
    padding,
    fontVariant,
    borderRadius,
    fontsize,
  }) => ({
    borderRadius: borderRadius,
    width: width,
    backgroundColor: backgroundColor || "transparent", // Use backgroundColor prop
    border: `2px dashed ${darkColors.dashedButton}`, // orange border
    padding: padding,
    color: "white",
    textTransform: "none",
    fontSize: fontsize,
    gap: theme.spacing(2),
    //   paddingRight: theme.spacing(4),
    fontWeight: fontVariant === "bold" ? 700 : 700, // Adjust font weight
    fontFamily: fontVariant === "bold" ? "MontserratBold" : "Montserrat", // Toggle font family
    "&:hover": {
      backgroundColor: backgroundColor ? backgroundColor : "#212121",
    },
    "& img": {
      paddingBottom: 4,
    },
  })
);

const DashedButton = ({
  icon,
  text,
  backgroundColor,
  width = "200px",
  padding = "10px 10px",
  onClick,
  fontVariant = "bold",
  borderRadius = "50px",
  fontsize = "clamp(12px, 1vw, 16px)",
}) => {
  return (
    <ConnectButton
      variant="contained"
      backgroundColor={backgroundColor}
      width={width}
      padding={padding}
      onClick={onClick}
      fontVariant={fontVariant}
      borderRadius={borderRadius}
      fontsize={fontsize}
    >
      {icon && (typeof icon === "string" ? <InlineSvg url={icon} /> : icon)}
      {text}
    </ConnectButton>
  );
};

export default DashedButton;
